<div class="disabled-approve flex !mt-2 bg-palette-base-white rounded-lg border general-information-ota-section">
    <div class="!p-6 !w-[31.55%]">
        <p class="font-inter !text-lg !font-semibold text-palette-gray-900">{{ "OTA.LANGUAGE.LANGUAGE_AND_CURRENCY" | translate }}</p>
        <p class="font-inter !text-sm !font-normal text-palette-gray-700 !mt-1">{{ "OTA.LANGUAGE.INFO" | translate }}
        </p>
    </div>

    <div class="!p-6 !w-[68.45%] ota-location-form">
        <form [formGroup]="formGroup" class="flex flex-col gap-3">
            <div>
                <p class="font-inter !text-sm !font-medium text-palette-gray-700">{{ "OTA.LANGUAGE.LANGUAGE" | translate
                    }}
                    <span class="text-palette-red-600">*</span>
                </p>
                <div class="!mt-1">
                    <p-multiSelect [options]="languages" formControlName="selectedlanguages" optionLabel="english_name"
                        optionValue="language_code"
                        [placeholder]="'OTA.LANGUAGE.SELECT_LANGUAGES' | translate"></p-multiSelect>
                </div>
                <div *ngIf="f['selectedlanguages'].touched && f['selectedlanguages'].errors"
                    class="!mt-1 invalid-feedback">
                    <div *ngIf="f['selectedlanguages'].errors['required']">
                        <div [message-error]="'OTA.LANGUAGE.LANGUAGE' | translate"></div>
                    </div>
                </div>
            </div>
            <div>
                <label htmlFor="city" class="font-inter text-sm font-medium text-palette-gray-700 mb-1">{{
                    "OTA.LANGUAGE.CURRENCY" |
                    translate }}
                    <span class="text-palette-red-600">*</span>
                </label>
                <input
                    class="form-disable !mt-1 pointer-events-none"
                    pInputText formControlName="currency"
                    type="text">
                <p class="text-xs font-normal text-palette-blue-600 !mt-1">
                    {{ "OTA.CURRENCY_TO_COUNTRY" | translate}}
                </p>
            </div>
        </form>
    </div>
</div>